// Shown while MsalAuthenticationTemplate is mid-redirect/token round-trip. Deliberately plain
// inline styles, not Chakra components (Center/Spinner/etc.) - those depend on Emotion injecting
// their CSS at runtime, and if that lags even one frame behind the initial paint, an unstyled
// Spinner renders at its default top-left position instead of centered (that's the "circle in the
// top-left" bug). Pixel-matching index.html's plain-CSS #splash (same colours, same spinner,
// same layout) means there's no visible seam between that pre-JS splash and this one either - it
// reads as one continuous splash, not two different-looking loading states in sequence.
export default function LoadingSplash() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        background: "#f7f4f9",
        fontFamily: "-apple-system, 'Segoe UI', Roboto, sans-serif",
        color: "#1a202c",
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          border: "4px solid #10325e33",
          borderTopColor: "#10325e",
          animation: "splash-spin 0.8s linear infinite",
        }}
      />
      <div>Loading Eyebright Office Portal…</div>
      <style>{"@keyframes splash-spin { to { transform: rotate(360deg); } }"}</style>
    </div>
  );
}
